import { createElement, Fragment } from "react";

export function assetUrl(value) {
  if (!value) return "";
  if (/^(?:https?:|data:|blob:)/i.test(value)) return value;
  const path = String(value).replace(/^\/+/, "");
  if (
    path.startsWith("media/") ||
    path.startsWith("resource-cover-templates/")
  ) {
    return `/${path}`;
  }
  return `/media/static/${path}`;
}

export function pageUrl(value) {
  if (!value || value === "#") return "#";
  if (/^(?:https?:|mailto:|tel:)/i.test(value)) return value;
  return `/${String(value).replace(/^\/+/, "")}`;
}

export function localized(item, field, lang) {
  return lang === "ID" ? item?.[`${field}_id`] || item?.[field] : item?.[field];
}

export function stripHtml(value = "") {
  const documentValue = new DOMParser().parseFromString(
    String(value),
    "text/html",
  );
  return documentValue.body.textContent?.trim() || "";
}

export function RichText({ as: Tag = "div", html, className }) {
  const source = new DOMParser().parseFromString(
    String(html || ""),
    "text/html",
  );
  const renderNode = (node, key) => {
    if (node.nodeType === Node.TEXT_NODE) return node.textContent;
    if (node.nodeType !== Node.ELEMENT_NODE) return null;
    const tag = node.tagName.toLowerCase();
    if (tag === "br") return <br key={key} />;
    const children = [...node.childNodes].map((child, index) =>
      renderNode(child, `${key}-${index}`),
    );
    if (tag === "span") {
      return createElement(tag, { key }, [...children, " "]);
    }
    if (["div", "p"].includes(tag)) {
      return (
        <Fragment key={key}>
          {children}
          <br />
        </Fragment>
      );
    }
    if (["strong", "b", "em", "i", "small"].includes(tag)) {
      return createElement(tag, { key }, children);
    }
    return <Fragment key={key}>{children}</Fragment>;
  };

  return (
    <Tag className={className}>
      {[...source.body.childNodes].map((node, index) =>
        renderNode(node, `rich-${index}`),
      )}
    </Tag>
  );
}

export async function postForm(url, form, csrfToken) {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "X-CSRF-TOKEN": csrfToken,
      "X-Requested-With": "XMLHttpRequest",
    },
    body: new FormData(form),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.status === "false") {
    throw new Error(payload.message || "Permintaan belum dapat diproses.");
  }
  return payload;
}
